<template>
  <div class="back-home">
    <span @click="backHome">{{ lang === 'zh' ? '返回首页' : 'Back Home' }}</span>
  </div>
</template>

<script>
export default {
  name: "BackHome",
  methods: {
    backHome() {
      const _path = this.lang === 'zh' ? '/mobile/home' : '/us/mobile/home';
      this.$router.push(_path);
      document.getElementById('app').scrollIntoView({ block: 'start' })
    }
  },
  computed: {
    lang() {
      return this.$store.state.mlang;
    }
  }
}
</script>

<style lang="less">
@import "../../common/theme";
.mobile-home {
  .back-home {
    text-align: right;
    padding-right: calc(@mobileFont * .55);
    margin-bottom: 30px;
    span {
      display: inline-block;
      color: #fff;
      background: #037698;
      padding: 3px 20px;
    }
  }
}
</style>
